<div class="comparison-table-container" *ngIf="!isLoading" #comparisonTableContainer>
  <nz-table
    #comparisonTable
    nzBordered
    [nzData]="transformedData"
    [nzScroll]="{ x: scrollX, y: scrollY }"
    nzSize="middle"
    [nzFrontPagination]="false"
    [nzShowPagination]="false"
    [nzLoading]="isLoading" 
    class="comparison-nz-table"
  >
    <thead>
      <tr>
        <th
          nzLeft
          [nzWidth]="fixedColumnWidth"
          class="feature-header-cell"
        >
        </th>
        <th
          *ngFor="let quote of quotations; let i = index"
          [nzWidth]="quotationColumnWidth"
          class="quotation-header-cell"
        >
          <h3 style="padding-bottom: 6px;margin-bottom:0px; text-align:left;color:#564df4;">
            
            <nz-avatar [nzText]="quote.propertyName[0].toUpperCase()" 
            [nzSrc]="getVendorIcon(quote.propertyName[0])" style="margin-right:0px;width:25px;height:25px"></nz-avatar>
            
            {{ quote.propertyName?.length >  25 ? quote.propertyName.substring(0, 25) + '...' : quote.propertyName}}
           
          </h3>
          <p class="property-type-header" style="padding-bottom: 5px;margin-bottom:0px;color:#9d9d9d;font-size: 10px;">{{ quote.propertyType | titlecase }}</p>
          
           <span style="float:left;font-size:10px; margin-top:5px;" *ngIf="quote?.isShortlisted || quote?.isFinalized">
              <nz-tag [nzColor]="'gold'" style="margin-right: 5px;" *ngIf="quote?.isShortlisted">Shortlisted</nz-tag>
              <span *ngIf="quote?.isShortlisted && quote?.isFinalized">&</span>
              <nz-tag [nzColor]="'success'" style="margin-left: 5px;" *ngIf="quote?.isFinalized">Finalized</nz-tag>
            </span>
        
        </th>
      </tr>
    </thead>
    <tbody>
      <tr *ngIf="!isLoading && quotations.length === 0">
        <td nzLeft [attr.colspan]="1 + (quotations.length > 0 ? quotations.length : 4)">
          <div class="message-center-content">No quotations selected for comparison.</div>
        </td>
      </tr>
      <tr *ngIf="!isLoading && quotations.length > 0 && transformedData.length === 0">
        <td nzLeft [attr.colspan]="quotations.length + 1">
          <div class="message-center-content">No comparable features/questions defined for the selected quotations.</div>
        </td>
      </tr>

      <ng-container *ngIf="!isLoading && transformedData.length > 0 && quotations.length > 0">
        <ng-container *ngFor="let row of transformedData;let i = index">
          <tr *ngIf="row.isGroupTitle" class="group-title-row">
            <td nzLeft class="group-title-cell-fixed">
              <h5>{{ row.featureLabel }}</h5>
            </td>
            <td class="group-title-cell-scrollable" [attr.colspan]="quotations.length">
            </td>
          </tr>
          <tr *ngIf="!row.isGroupTitle" class="data-row">
            <td nzLeft class="feature-label-cell"> {{ row.featureLabel }}
            </td>
            <td
              *ngFor="let quote of quotations; let i = index"
              class="data-cell" >
              <ng-container [ngSwitch]="row.originalQuestionType">
                <span *ngSwitchCase="'TEXT_SHORT'">
                  {{ getValue(quote, row.dataKey) || 'N/A' }}
                </span>
                <span *ngSwitchCase="'TEXT_LONG'">
                  <p class="notes-text">{{ getValue(quote, row.dataKey) || 'N/A' }}</p>
                </span>
                <span *ngSwitchCase="'NUMBER'">
                  {{ getValue(quote, row.dataKey) === undefined || getValue(quote, row.dataKey) === null ? 'N/A' : getValue(quote, row.dataKey) }}
                </span>
                <span *ngSwitchCase="'CURRENCY'">
                  {{ getValue(quote, row.dataKey) === undefined || getValue(quote, row.dataKey) === null ? 'N/A' : (getValue(quote, row.dataKey) | currency:'USD':'symbol':'1.2-2') }}
                </span>
                <span *ngSwitchCase="'BOOLEAN'">
                  <nz-tag [nzColor]="getYesNoTagType(getValue(quote, row.dataKey))">
                    {{ getValue(quote, row.dataKey) === undefined || getValue(quote, row.dataKey) === null ? 'N/A' : (getValue(quote, row.dataKey) ? 'Yes' : 'No') }}
                  </nz-tag>
                </span>
                <span *ngSwitchCase="'DATE'">
                  {{ formatDate(getValue(quote, row.dataKey)) }}
                </span>
                <ng-container *ngSwitchCase="'FILE_UPLOAD'">
                  <div *ngIf="getValue(quote, row.dataKey) && getValue(quote, row.dataKey).length > 0">
                    <p class="file-list-header">Attached Files:</p>
                    <nz-list nzBordered nzHeader="" nzFooter="" class="file-list">
                      <nz-list-item *ngFor="let fileRef of getValue(quote, row.dataKey)">
                        <ng-container *ngIf="fileRef.file_url">
                          <ng-container *ngIf="isImageFile(fileRef.file_url); else fileIcon">
                            <img nz-image width="60px" height="40px" [nzSrc]="fileRef.file_url" alt="" />
                          </ng-container>
                          <ng-template #fileIcon>
                            <i nz-icon nzType="file" nzTheme="outline" style="font-size: 24px; margin-right: 8px;"></i>
                          </ng-template>
                          <a [href]="fileRef.file_url" target="_blank" download style="display:inline-block; margin-left: 8px;">
                            {{ fileRef.file_name || (fileRef.file_url | slice: (fileRef.file_url.lastIndexOf('/')+1)) }}
                          </a>
                        </ng-container>
                      </nz-list-item>
                    </nz-list>
                  </div>
                  <span *ngIf="!getValue(quote, row.dataKey) || getValue(quote, row.dataKey).length === 0">N/A</span>
                </ng-container>
                <ng-container *ngSwitchCase="'MULTIPLE_FILES'">
                  <div *ngIf="getValue(quote, row.dataKey) && getValue(quote, row.dataKey).length > 0">
                    <p class="file-list-header">Attached Files:</p>
                    <nz-list nzBordered nzHeader="" nzFooter="" class="file-list">
                      <nz-list-item *ngFor="let fileRef of getValue(quote, row.dataKey)">
                        <ng-container *ngIf="fileRef.file_url">
                          <ng-container *ngIf="isImageFile(fileRef.file_url); else fileIcon">
                            <img nz-image width="60px" height="40px" [nzSrc]="fileRef.file_url" alt="" />
                          </ng-container>
                          <ng-template #fileIcon>
                            <i nz-icon nzType="file" nzTheme="outline" style="font-size: 24px; margin-right: 8px;"></i>
                          </ng-template>
                          <a [href]="fileRef.file_url" target="_blank" download style="display:inline-block; margin-left: 8px;">
                            {{ fileRef.file_name || (fileRef.file_url | slice: (fileRef.file_url.lastIndexOf('/')+1)) }}
                          </a>
                        </ng-container>
                      </nz-list-item>
                    </nz-list>
                  </div>
                  <span *ngIf="!getValue(quote, row.dataKey) || getValue(quote, row.dataKey).length === 0">N/A</span>
                </ng-container>
                <span *ngSwitchCase="'MULTIPLE_CHOICE_SINGLE'">
                  {{ getValue(quote, row.dataKey) || 'N/A' }}
                </span>
                <span *ngSwitchCase="'DROPDOWN'">
                  {{ getValue(quote, row.dataKey) || 'N/A' }}
                </span>
                <ul *ngSwitchCase="'MULTIPLE_CHOICE_MULTI'" class="multi-choice-list">
                  <li *ngFor="let item of getValue(quote, row.dataKey)">
                    {{ item }}
                  </li>
                  <li *ngIf="!getValue(quote, row.dataKey) || getValue(quote, row.dataKey).length === 0">N/A</li>
                </ul>

                <span *ngSwitchCase="'CUSTOM_CURRENCY'">
                  {{ getValue(quote, row.dataKey) || 'N/A' }}
                </span>
                <span *ngSwitchCase="'CUSTOM_AMOUNT_BEFORE_TAX'">
                  {{ getValue(quote, row.dataKey) === undefined || getValue(quote, row.dataKey) === null ? 'N/A' : (getValue(quote, row.dataKey) | currency: quote.currency || 'USD' : 'symbol' : '1.2-2') }}
                </span>
                <ng-container *ngSwitchCase="'CUSTOM_TAXES'">
                  <div *ngIf="getValue(quote, row.dataKey) && getValue(quote, row.dataKey).length > 0">
                    <p class="tax-list-header">Taxes:</p>
                    <nz-list nzBordered class="tax-list">
                      @for (tax of getValue(quote, row.dataKey); track tax) {
                        <nz-list-item>
                          {{ tax.name }}: {{ tax.value | currency: quote.currency || 'USD' : 'symbol' : '1.2-2' }}
                        </nz-list-item>
                      }
                    </nz-list>
                  </div>
                  <span *ngIf="!getValue(quote, row.dataKey) || getValue(quote, row.dataKey).length === 0">N/A</span>
                </ng-container>
                <span *ngSwitchCase="'CUSTOM_TOTAL_PRICE'">
                  {{ getValue(quote, row.dataKey) === undefined || getValue(quote, row.dataKey) === null ? 'N/A' : (getValue(quote, row.dataKey) | currency: quote.currency || 'USD' : 'symbol' : '1.2-2') }}
                </span>
                <span *ngSwitchCase="'CUSTOM_EXCHANGE_RATE'">
                  {{ getValue(quote, row.dataKey) === undefined || getValue(quote, row.dataKey) === null ? 'N/A' : getValue(quote, row.dataKey) }}
                </span>
                <span *ngSwitchCase="'CUSTOM_USD_AMOUNT'">
                  {{ getValue(quote, row.dataKey) === undefined || getValue(quote, row.dataKey) === null ? 'N/A' : (getValue(quote, row.dataKey) | currency:'USD' : 'symbol' : '1.2-2') }}
                </span>
                <ng-container *ngSwitchCase="'CUSTOM_ADDITIONAL_FILES'">
                  <ng-container *ngIf="getValue(quote, row.dataKey) as files">
                    <ng-container *ngIf="files.length > 0; else noAdditionalFiles">
                      <p class="file-list-header">Additional Files:</p>
                      <nz-list nzBordered class="file-list">
                        @for (file of files; track file) {
                          <nz-list-item>
                            <ng-container *ngIf="file.url; else missingFile">
                              <ng-container *ngIf="isImageFile(file.url); else fileIcon">
                                <img nz-image width="60px" height="40px" [nzSrc]="file.url" alt="" />
                              </ng-container>
                              <ng-template #fileIcon>
                                <i nz-icon nzType="file" nzTheme="outline" style="font-size: 24px; margin-right: 8px;"></i>
                              </ng-template>
                              <a [href]="file.url" target="_blank" download style="display:inline-block; margin-left: 8px;">
                                {{ file.name || getFileNameFromUrl(file.url) }}
                              </a>
                            </ng-container>
                            <ng-template #missingFile>
                              <span>N/A</span>
                            </ng-template>
                          </nz-list-item>
                        }
                      </nz-list>
                    </ng-container>
                  </ng-container>
                  <ng-template #noAdditionalFiles>
                    <span>N/A</span>
                  </ng-template>
                </ng-container>
                <span *ngSwitchDefault>
                  {{ getValue(quote, row.dataKey) === undefined || getValue(quote, row.dataKey) === null ? 'N/A' : getValue(quote, row.dataKey) }}
                </span>
              </ng-container>
            </td>
          </tr>
        </ng-container>
      </ng-container>
    </tbody>
    <tfoot style="position: sticky; bottom: 0; background: white;z-index:999">
      <tr>
        <td
          nzLeft
          class="actions-footer-label-cell" >
            <div class="extra-space-actions-cell" style="color:#564df4;">
              Actions
            </div>
          </td>
        <td
          *ngFor="let quote of quotations"
          class="actions-cell" >
            <button nz-button [nzType]="quote.isShortlisted ? 'primary' : 'default'"  style="margin-right: 8px;"
            (click)="markAsShortlisted(quote)" [disabled]="isLoading">
              {{ quote.isShortlisted ? 'Shortlisted' : 'Shortlist' }}
            </button>

            <button nz-button [nzType]="quote.isFinalized ? 'primary' : 'default'"
            (click)="markAsFinalized(quote)" [disabled]="isLoading">
              {{ quote.isFinalized ? 'Finalized': 'Finalize' }}
            </button>
        </td>
      </tr>
    </tfoot>
  </nz-table>
</div>

<div class="comparison-table-container" *ngIf="isLoading">
  <nz-table
    nzBordered
    [nzScroll]="{ x: scrollX, y: scrollY }"
    nzSize="middle"
    [nzFrontPagination]="false"
    [nzShowPagination]="false"
    [nzData]="[]" 
    [nzNoResult]="null" 
  >
    <thead>
      <tr>
        <th
          nzLeft
          [nzWidth]="fixedColumnWidth"
          class="feature-header-cell"
        >
        </th>
        <th
          *ngFor="let _ of [].constructor(4)" [nzWidth]="quotationColumnWidth"
          class="quotation-header-cell"
        >
          <nz-skeleton-element nzType="input" [nzActive]="true" ></nz-skeleton-element>
          <nz-skeleton-element nzType="input" [nzActive]="true" ></nz-skeleton-element>
        </th>
      </tr>
    </thead>
    <tbody>
       <tr *ngFor="let _ of [].constructor(4)"> 
    <td [style.width]="fixedColumnWidth"> <nz-skeleton-element nzType="input" [nzActive]="true" style="width: 80%;"></nz-skeleton-element>
    </td>
    <td *ngFor="let __ of [].constructor(4)" [style.width]="quotationColumnWidth"> <nz-skeleton-element nzType="input" [nzActive]="true" style="width: 90%;"></nz-skeleton-element>
    </td>
  </tr>


  <tr *ngFor="let _ of [].constructor(4)"> 
    <td [style.width]="fixedColumnWidth"> <nz-skeleton-element nzType="input" [nzActive]="true" style="width: 80%;"></nz-skeleton-element>
    </td>
    <td *ngFor="let __ of [].constructor(4)" [style.width]="quotationColumnWidth"> <nz-skeleton-element nzType="input" [nzActive]="true" style="width: 90%;"></nz-skeleton-element>
    </td>
  </tr>
  
      </tbody>
    <tfoot style="position: sticky; bottom: 0; background: white;z-index:999">
      <tr>
        <td
          nzLeft
          class="actions-footer-label-cell" >
          <nz-skeleton-element nzType="input" [nzActive]="true" ></nz-skeleton-element>
        </td>
        <td
          *ngFor="let _ of [].constructor(4)" class="actions-cell" >
            <nz-skeleton-element nzType="button" [nzActive]="true" nzSize="small" style="width: 80px; margin-right: 8px;"></nz-skeleton-element>
            <nz-skeleton-element nzType="button" [nzActive]="true" nzSize="small" style="width: 80px;"></nz-skeleton-element>
        </td>
      </tr>
    </tfoot>
  </nz-table>
</div>